import { render } from "./DictionaryForm.vue?vue&type=template&id=6f8edf8c"
import script from "./DictionaryForm.vue?vue&type=script&lang=js"
export * from "./DictionaryForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__